import Api from '@/services/Api'
const path = 'client'

export default {
    login(login, password) {
        return Api().get(path + `/login`, {
            params: {
                login,
                password
            }
        })
    },
    changePassword(newPassword) {
        return Api().post(path + `/changePassword`, {
            newPassword,
            hasChangedPassword: true
        })
    },
    createUpdate(item) {
        return Api().post(path + `/createUpdate`, {
            id: item.id,
            password: item.password,
            isActive: item.isActive
        })
    },
    getAddresses() {
        return Api().get(path + `/addresses`, {})
    },
    getAddressesSalesman(id) {
        return Api().get(path + `/addressesbyid`, {
            params: {
                id
            }
        })
    },
    getAddressesAdmin(id) {
        return Api().get(path + `/addressesbyidadmin`, {
            params: {
                id
            }
        })
    },
    list(name, login, externalId) {
        return Api().get(path + `/listsalesman`, {
            params: {
                name,
                login,
                externalId
            }
        })
    },
    listAdmin(name, login, externalId, active, page) {
        return Api().get(path + `/list`, {
            params: {
                name,
                login,
                externalId,
                active,
                page
            }
        })
    },
    getFullInfo(id) {
        return Api().get(path + `/getFullInfo`, {
            params: {
                id
            }
        })
    }
}